import { fabric } from 'fabric';
import { useEffect } from 'react';

import { useMouseEvents } from '~/UI/components/organisms/FabricCanvas/hooks/useMouseEvents';
import {
  useDrawingShapeContext,
  useFabricCanvasContext,
} from '~/legacy/easy-estimator-page/context';
import { useAppSelector } from '~/redux/hooks';
import { selectFabricCanvas } from '~/redux/slices/fabric';

const useFabricCanvasEvents = () => {
  const canvas = useAppSelector(selectFabricCanvas);

  const {
    getters: { drawingShapes },
  } = useDrawingShapeContext();

  const { drawingShapesRef } = useFabricCanvasContext();

  const { onDrop, onMouseDownBefore, onMouseDown, onMouseMove, onMouseUp } =
    useMouseEvents();

  drawingShapesRef.current = drawingShapes;

  useEffect(() => {
    if (!canvas) {
      return undefined;
    }

    canvas.on('drop', onDrop);
    canvas.on('mouse:down:before', onMouseDownBefore);
    canvas.on('mouse:down', onMouseDown);
    canvas.on('mouse:up', onMouseUp);
    canvas.on('mouse:move', onMouseMove);

    return () => {
      type OffHandler = (e: fabric.IEvent) => void;
      canvas.off('drop', onDrop as OffHandler);
      canvas.off('mouse:down:before', onMouseDownBefore as OffHandler);
      canvas.off('mouse:down', onMouseDown as OffHandler);
      canvas.off('mouse:up', onMouseUp as OffHandler);
      canvas.off('mouse:move', onMouseMove as OffHandler);
    };
  }, [canvas, onDrop, onMouseDown, onMouseDownBefore, onMouseMove, onMouseUp]);
};

export default useFabricCanvasEvents;
